import React from 'react';
import styled from 'styled-components';

import { Header, Footer } from '@src/features/common';
import { Flex, LayoutBox, LayoutBoxProps } from 'src/kit';

export type MainLayoutProps = LayoutBoxProps & {
  sidebar?: React.FunctionComponent;
  header?: React.ReactNode;
  subnav?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  contentStyledProps?: any;
  contentLayoutProps?: any;
  mainLayoutProps?: any;
};

export const MainLayout = ({
  children,
  header = <Header />,
  subnav,
  contentStyledProps,
  sidebar: Sidebar,
  footer = <Footer />,
  maxWidth = 1400,
  mainLayoutProps = {},
  contentLayoutProps = {},
  ...styledProps
}: MainLayoutProps) => (
  <StyledContent {...mainLayoutProps}>
    <Flex className="layout">
      {Sidebar && <Sidebar />}
      <div className="content-layout" {...contentLayoutProps}>
        {header}
        <Flex
          className="main"
          flex="1 0 auto"
          p="20px 30px 50px"
          flexWrap={{ xs: 'wrap', md: 'nowrap' }}
          minHeight={getHeight({ header, footer })}
          {...styledProps}
        >
          {subnav}
          <LayoutBox mx="auto" flex="1 1 0%" maxWidth={maxWidth} {...contentStyledProps}>
            {children}
          </LayoutBox>
        </Flex>
        {footer}
      </div>
    </Flex>
  </StyledContent>
);

const StyledContent = styled.div<{ sidebar?: boolean }>`
  height: 100%;

  .content-layout {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 100%;
  }
`;

const getHeight = ({ header, footer }) => {
  if (footer) return 'contentWithFooter';
  if (header) return 'contentWithHeader';
  return 'baseContent';
};
